import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ImageItem } from 'src/app/shared/ui/sera-image/models/image-item';

@Component({
    selector: 'sera-image',
    templateUrl: './sera-image.component.html',
    styleUrls: ['./sera-image.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraImageComponent {
    @Input()
    imageItem?: ImageItem;

    @Input()
    placeholder?: string = 'ci ci-image';

    @Input()
    showLabel: boolean = true;

    @Input()
    readOnly = false;

    @Input()
    noStyle: boolean = false;

    @Input()
    transparentImage: boolean = false;

    @Output()
    imageClickEmitter = new EventEmitter<number>();

    handleImageClick() {
        this.imageClickEmitter.emit(this.imageItem?.id);
    }

    getImageClass(imageItem: ImageItem): any {
        if (this.noStyle) return;
        if (imageItem?.src && imageItem?.disableInteractions) return 'image-placeholder__image--disable-interactions';
        if (this.transparentImage) {
            return {
                'image-placeholder__image--default-transparent': !imageItem?.isSelected && !imageItem?.isInvalid && (imageItem?.isSelectable || !this.readOnly),
                'image-placeholder__image--selected-transparent': imageItem?.src && imageItem?.isSelected,
                'image-placeholder__image--invalid': imageItem?.isInvalid && !imageItem?.isSelected,
                'image-placeholder__image--non_selectable': imageItem?.src && (!imageItem?.isSelectable || this.readOnly)
            };
        }

        return {
            'image-placeholder__image--default': !imageItem?.isSelected && !imageItem?.isInvalid && (imageItem?.isSelectable || !this.readOnly),
            'image-placeholder__image--selected': imageItem?.src && imageItem?.isSelected,
            'image-placeholder__image--invalid': imageItem?.isInvalid && !imageItem?.isSelected,
            'image-placeholder__image--non_selectable': imageItem?.src && (!imageItem?.isSelectable || this.readOnly)
        };
    }
}
